import React, { useEffect, useState } from 'react'
import {
  IonPopover,
  IonButton,
  IonList,
  IonItem
} from '@ionic/react'
import ReactTooltip from 'react-tooltip'
import YokIcon from '../YokIcon'
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share'
import { appBasePath } from '../../../config/app'
import './styles.scss'

export const ShareMenu = (props) => {
  const { title, intro, tags, section } = props
  const [popoverState, setShowPopover] = useState({ showPopover: false, event: undefined })
  const [url, setUrl] = useState(false)
  const [email, setEmail] = useState(false)
  const [facebook, setFacebook] = useState(false)
  const [telegram, setTelegram] = useState(false)
  const [twitter, setTwiter] = useState(false)
  const [whatsapp, setWhatsapp] = useState(false)

  const html2text = (html) => {
    const tag = document.createElement('div')
    tag.innerHTML = html
    return tag.innerText
  }

  const openPopover = (e) => {
    e.persist()
    setShowPopover({ showPopover: true, event: e })
  }

  useEffect(() => {
    const _section = section || 'Yok Radio'
    const _url = `${appBasePath}${window.location.pathname}`
    const _parsedIntro = html2text(intro)
    setUrl(_url)

    const _email = {
      body: `${title} \n ${_parsedIntro} \n Podés ver el contenido en ${_url} \n ${_section}`,
      subject: _section + ' | ' + title
    }
    setEmail(_email)

    const _facebook = {
      quote: `${section} | ${title} | ${_parsedIntro}`
    }
    setFacebook(_facebook)

    const _telegram = {
      title: `${title} \n ${_parsedIntro} \n Yok Radio`
    }
    setTelegram(_telegram)

    const _twitter = {
      title: _section + ' | ' + title,
      hashtags: []
    }

    if (Array.isArray(tags) === true) {
      tags.map((tag) => {
        _twitter.hashtags.push(tag.name.replace(/\s+/g, ''))
        return _twitter.hashtags
      })
    }
    setTwiter(_twitter)

    const _whatsapp = {
      title: `*${title}* \n _${_parsedIntro}_ \n *_Yok Radio_*`,
      separator: ' \n'
    }
    setWhatsapp(_whatsapp)
  }, [title, intro, tags, section])

  return (
    <div className='share-menu'>
      <IonButton
        onClick={openPopover}
        dataTip='Compartir'
      >
        <YokIcon name='share' />
      </IonButton>
      <ReactTooltip
        backgroundColor='#ffb300'
        textColor='#000'
      />
      <IonPopover
        cssClass='share-menu-popover'
        showBackdrop={false}
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <IonList>
          {email &&
            <IonItem lines='none'>
              <EmailShareButton
                className='email'
                subject={email.title}
                body={email.body}
                url={url}
              >
                <YokIcon name='mail_outline' />
              </EmailShareButton>
            </IonItem>}
          {facebook &&
            <IonItem lines='none'>
              <FacebookShareButton
                className='facebook'
                url={url}
                quote={facebook.quote}
              >
                <YokIcon name='facebook' />
              </FacebookShareButton>
            </IonItem>}
          {telegram &&
            <IonItem lines='none'>
              <TelegramShareButton
                className='telegram'
                url={url}
                title={telegram.title}
              >
                <YokIcon name='paper-plane-o' />
              </TelegramShareButton>
            </IonItem>}
          {twitter &&
            <IonItem lines='none'>
              <TwitterShareButton
                className='twitter'
                url={url}
                title={twitter.title}
                hashtags={twitter.hashtags}
              >
                <YokIcon name='twitter' />
              </TwitterShareButton>
            </IonItem>}
          {whatsapp &&
            <IonItem lines='none'>
              <WhatsappShareButton
                className='whatsapp'
                url={url}
                title={whatsapp.title}
                separator={whatsapp.separator}
              >
                <YokIcon name='whatsapp' />
              </WhatsappShareButton>
            </IonItem>}
        </IonList>
      </IonPopover>
    </div>
  )
}
